import { useState, useEffect, useCallback } from 'react'
import { getData as apiGetData } from 'api/Api'
import { CancelError } from '@kanbo/api'
import useIsMounted from './useIsMounted'

export default function useGetData<TData>(method, args?) {
  const [_fetch, setFetch] = useState(true)
  const [data, setData] = useState<TData | null>(null)
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const isMounted = useIsMounted()

  const fetch = useCallback(() => {
    setFetch(value => !value)
  }, [])

  useEffect(() => {
    if (method) {
      let fetchPromise

      const fetchData = async () => {
        setData(null)
        setError(null)
        setIsLoading(true)
        setIsLoaded(false)

        fetchPromise = apiGetData(method, args)

        try {
          const data = await fetchPromise

          if (isMounted.current) {
            setData(data)
            setError(null)
            setIsLoading(false)
            setIsLoaded(true)
          }
        } catch (e) {
          if (isMounted.current) {
            if (!(e instanceof CancelError)) {
              setData(null)
              setError(e)
              setIsLoading(false)
              setIsLoaded(false)
            }
          }
        }
      }

      fetchData()

      return () => {
        fetchPromise.cancel()
      }
    }
  }, [method, args, isMounted, _fetch])

  return { data, error, isLoading, isLoaded, setData, fetch }
}
